// AreasDropdown.js - MODIFIED to support filtering
import React, { useEffect, useState } from "react";
import { Form, Select } from 'antd';
import AreasApi from "../Apis/AreasApi";

const AreaDropdown = ({ disabled, departmentId, form, required = true }) => {
    const [areas, setAreas] = useState([]);
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [page, setPage] = useState(0);

    const fetchAreas = async (reset = false) => {
        if (!departmentId) {
            setAreas([]);
            if (form) form.setFieldsValue({ areaId: undefined });
            return;
        }

        try {
            setLoading(true);
            const currentPage = reset ? 0 : page;
            
            // If your API supports filtering by department
            const response = await AreasApi.ListAreasByDepartmentId(departmentId, currentPage, 10);
            
            if (reset) {
                setAreas(response?.payloadDto || []);
                setPage(1);
            } else {
                setAreas(prev => [...prev, ...(response?.payloadDto || [])]);
                setPage(prev => prev + 1);
            }
            setHasMore(currentPage + 1 < (response.totalPages || 0));
            setLoading(false);
        } catch (error) {
            console.error('Error fetching areas:', error);
            setLoading(false);
        }
    };

    const handleScroll = (e) => {
        const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
        if (bottom && hasMore && !loading && departmentId) {
            fetchAreas(false);
        }
    };

    useEffect(() => {
        if (departmentId) {
            fetchAreas(true);
        } else {
            setAreas([]);
            if (form) form.setFieldsValue({ areaId: undefined });
        }
    }, [departmentId]);

    return (
        <Form.Item
            name="areaId"
            label="Area *"
            className="text-lable"
            rules={required ? [{
                required: true,
                message: "Please Select Area.",
            }] : []}
        >
            <Select
                disabled={disabled || !departmentId}
                className="control-Select mb-1"
                placeholder={departmentId ? "Select Area" : "Please select department first"}
                onPopupScroll={handleScroll}
                allowClear
            >
                {areas.map((option) => (
                    <Select.Option key={option.id} value={option.id}>
                        {option.areaName}
                    </Select.Option>
                ))}
                {loading && (
                    <Select.Option disabled key="loading" value="loading">
                        Loading...
                    </Select.Option>
                )}
            </Select>
        </Form.Item>
    );
};

export default AreaDropdown;